<template>
  <div class="flex items-center justify-between">
    <div class="flex-1">
      <p
        v-if="selectedSong"
        class="text-text-primary font-medium"
      >
        Selected: {{ selectedSong }}
      </p>
      <p
        v-else
        class="text-text-secondary"
      >
        Select a song to start
      </p>
    </div>

    <button
      class="px-4 py-2 rounded-xl font-semibold transition-all bg-primary text-text-primary hover:bg-primary/90 disabled:cursor-not-allowed disabled:opacity-50"
      :disabled="disabled"
      @click="$emit('start')"
    >
      Start Session
    </button>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  selectedSong?: string;
  disabled?: boolean;
}>();

defineEmits<{
  (e: 'start'): void;
}>();
</script>
